<!-- RecaptchaElement.vue -->


<template>
    <ElementLayout>
      <template #element>
        <div ref="div$" :data-sitekey="siteKey">{{ loadingMessage }}</div>
      </template>
  
      <!-- Default element slots -->
      <template v-for="(component, slot) in elementSlots" #[slot]>
        <slot :name="slot" :el$="el$">
          <component :is="component" :el$="el$" />
        </slot>
      </template>
    </ElementLayout>
  </template>
    
  <script>
  import { defineElement } from '@vueform/vueform/src/core.js'
  import { ref, onMounted } from 'vue'
  import formHelper from './utils/form-helper.js'
  import { waitForGlobal } from './utils/wait-for-global.js'
  
  
  export default defineElement({
    name: 'RecaptchaElement',
    props: {
      siteKey: {
        type: String,
        default: '',
        required: false
      }
    },
    setup(props, { element }) {
  
      const siteKey = ref(props.siteKey);
      const loadingMessage = ref('Loading...');
  
      //support getting the recaptcha key out of the parent DynamicForm if its available
      //and a particular key is not set in the element properties
      if (!siteKey.value)
        siteKey.value = formHelper.getDynamicForm(element.form$)?.model?.recaptchaKey;
  
      function recaptchaVerify(data) {
        console.log("VFP: captcha submitted");
        element.update(data);
      }
  
      function recaptchaExpired(data) {
  
        if(!formHelper.getDynamicForm(element.form$)?.formCompleted){
          console.log("VFP: captcha expired")
          element.update('');
        } else {
          console.log("VFP: captcha expired, but form was already completed");
        }
      }
  
  
  
      const div$ = ref(null);
      onMounted(() => {
  
        waitForGlobal("window.grecaptcha.render", () => {
          grecaptcha.render(div$.value, { "callback": recaptchaVerify, "expired-callback": recaptchaExpired });
          console.log('VFP: captcha element mounted');
        }, () => {
          console.log("VFP: no recaptcha library available")
          loadingMessage.value = ''
          element.update('recaptcha_failed');
        });
  
      })
  
  
      return {
        div$,
        siteKey,
        loadingMessage
      }
    }
  })
  </script>